import { createContext } from 'react';

const AuthContext = createContext({
    isLoggedIn: false,
    token: null,
    userInfose: null,
    login: () => {},
    logout: () => {}
});

export default AuthContext;